import { Progress } from "@always_faithful/shadcn/components/ui/progress"
import {useEffect, useState} from "react";

function PendingPage() {

    const [progress, setProgress] = useState(10);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => prev<95 ? prev + 10 : prev);
        })
        return () => clearInterval(interval);
    }, [500]);
    return (
        <div className="fixed top-0 left-0 w-full h-full z-50 bg-white">
            <div className="flex flex-col items-center justify-center h-screen">
                <Progress value={progress} className="w-[70%]" />
                <p>Loading...</p>
            </div>
        </div>
    )
}

export default PendingPage;